import React, { useContext, useEffect, useRef } from 'react'
import ImagesHeader from 'app/react/components/images/ImagesHeader'
import ImagesContext from 'app/react/components/images/ImagesContext'
import useFilter from 'app/react/components/images/useFilter'
import Image from 'app/react/components/images/Image'
import Pagination from 'app/react/components/Pagination'
import classNames from 'classnames'

export default function ImagesContent () {

  const { images, activePage, totalPages, texts, setContainerRef, isLoading } = useContext(ImagesContext)
  const { setPage } = useFilter()

  const containerRef = useRef(null)

  useEffect(() => {
    setContainerRef(containerRef)
  }, [containerRef])

  return (
    <section id="images" className={classNames('dm-images', {
      'dm-images--is-loading': isLoading
    })} ref={containerRef}>
      <div className="dm-images__inner dm-page-container">
        <ImagesHeader />
        <div className="dm-images__images">
          {images.length > 0 ?
            images.map((image, i) => <Image key={i} {...image}/>) :
            (<div className="dm-images__error dm-wysiwyg">{texts.errorMessage}</div>)
          }
        </div>
        <Pagination
          containerClass="dm-images__pagination"
          totalPages={totalPages}
          setPage={setPage}
          activePage={activePage}
        />
      </div>
    </section>
  )
}
